<template>
    <v-container>
        <h1 class="titulo mb-3">Configuração de E-mail para Análise de Crédito</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="formEmailAnalise" @submit.prevent="sendEmailAnalise">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                    label="E-mail do Destinatário:"
                                    placeholder="Digite o e-mail do Destinatário"
                                    class="required"
                                    outlined
                                    :rules="[$rules.required, $rules.email]"
                                    maxlength="255"
                                    v-model="form_data.email_destinatario"
                            />
                        </v-col>
                        <v-col cols="6">
                            <Autocomplete
                                    label="Ação Análise de Crédito: *"
                                    placeholder="Selecione a ação de Análise de Crédito"
                                    :items="tiposAnaliseCredito"
                                    item-text="label"
                                    item-value="value"
                                    v-model="form_data.acoes_analise_credito"
                                    :rules="[$rules.required]"
                                    outlined
                                    multiple
                                    chips
                                    deletable-chips
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <Autocomplete
                                    label="Tipo do Grupo: *"
                                    placeholder="Selecione o Tipo de Grupo"
                                    :items="tiposGrupo"
                                    item-text="label"
                                    item-value="value"
                                    v-model="form_data.tipo_grupo"
                                    :rules="[$rules.required]"
                                    outlined
                                    multiple
                                    chips
                                    deletable-chips
                            />
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-btn class="transition mr-4" color="secondary" type="reset" @click="resetForm">Limpar</v-btn>
                        <v-btn class="transition mr-4" color="primary" type="submit">Salvar</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { get } from 'lodash'
  import { AlertTypes } from '@/plugins/alerts_types'
  import { notification } from '@/plugins/helpers'
  import { TiposGrupoFiltro, TiposAnaliseCredito } from '@/plugins/constants'

  export default {
    name: 'FormularioCadastroEmailAnaliseCredito',
    props: {
      emailEdicao: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        tiposGrupo: TiposGrupoFiltro,
        tiposAnaliseCredito: TiposAnaliseCredito,
        form_data: {
          id_cadastro: null,
          email_destinatario: null,
          tipo_grupo: [],
          acoes_analise_credito: []
        }
      }
    },
    computed: {
      emailParaEditar: {
        get () {
          return this.emailEdicao
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      emailParaEditar (email) {
        if (email && email.email_destinatario) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          this.form_data = {
            id_cadastro: email.id_cadastro,
            email_destinatario: email.email_destinatario,
            tipo_grupo: email.tipo_grupo || [],
            acoes_analise_credito: email.acoes_analise_credito || []
          }
        }
      }
    },
    methods: {
      limpaEmailEdicao () {
        this.$emit('limpaEmailEdicao')
      },
      resetForm () {
        this.form_data = {
          id_cadastro: null,
          email_destinatario: null,
          tipo_grupo: [],
          acoes_analise_credito: []
        }

        if (this.$refs.formEmailAnalise) {
          this.$refs.formEmailAnalise.reset()
        }

        this.limpaEmailEdicao()
      },
      async sendEmailAnalise () {
        if (!this.$refs.formEmailAnalise.validate()) {
          return
        }

        const formData = new FormData()
        if (this.form_data.id_cadastro) {
          formData.append('id_cadastro', parseInt(this.form_data.id_cadastro))
        }
        formData.append('email_destinatario', this.form_data.email_destinatario)
        if (!Array.isArray(this.form_data.tipo_grupo)) {
          this.form_data.tipo_grupo = [this.form_data.tipo_grupo]
        }
        if (!Array.isArray(this.form_data.acoes_analise_credito)) {
          this.form_data.acoes_analise_credito = [this.form_data.acoes_analise_credito]
        }

        this.form_data.tipo_grupo.forEach(v => formData.append('tipo_grupo[]', v))
        this.form_data.acoes_analise_credito.forEach(v => formData.append('acoes_analise_credito[]', v))

        await this.$http
          .post('/painel/cadastro/email-analise-credito/salvar', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then((response) => {
            notification(
              AlertTypes.SUCCESS,
              `${this.emailEdicao ? 'Configuração de e-mail atualizada' : 'Nova configuração de e-mail cadastrada'} com sucesso!`
            )
            this.$emit('registroInserido')
            this.resetForm()
          })
          .catch((err) => {
            const error_message = get(err, 'response.data.Msg_Erro', null)
            if (error_message) {
              notification(
                AlertTypes.ERROR,
                `Erro ao ${this.emailEdicao ? 'atualizar' : 'cadastrar'} a configuração de e-mail: ${error_message}`
              )
            } else {
              notification(
                AlertTypes.ERROR,
                `Erro ao ${this.emailEdicao ? 'atualizar' : 'cadastrar'} a configuração de e-mail. Tente novamente.`
              )
            }
          })
      }
    }
  }
</script>
